import React from 'react';
import {ScrollView, StyleSheet} from 'react-native';

import PaymentMethod from '../../components/payments/till/PaymentMethod';
import ContentView from '../../components/ui-controls/layout/ContentView';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';

const PaymentMethodScreen = (
  _: RouteNavigatorScreenProps<AppRoute.ACCOUNT_PAYMENT_METHOD>,
) => (
  <ContentView>
    <ScrollView contentContainerStyle={styles.main}>
      <PaymentMethod navigationTarget={AppRoute.ACCOUNT_PAYMENT_METHOD} />
    </ScrollView>
  </ContentView>
);

export default PaymentMethodScreen;

const styles = StyleSheet.create({
  main: {
    flex: 1,
    alignItems: 'stretch',
    justifyContent: 'center',
    zIndex: 50,
  },
});
